import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {UserInfoMetaClient, GetUserProfileClient, UpdateUserProfileClient} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

// API Clients
const userInfoMetaClient = new UserInfoMetaClient(SERVICE_URL)
const getUserProfileClient = new GetUserProfileClient(SERVICE_URL)
const updateUserProfileClient = new UpdateUserProfileClient(SERVICE_URL)

const initialState = {
  loading: false,
  isRedirect: false,
  error: null,
  isDeleted: false,
  isArchived: false,
  info: null,
  userProfile: null,
}

// Async Thunks
export const profileGetInfo = createAsyncThunk('profile/getInfo', async (_, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await userInfoMetaClient.info()
    dispatch(setInfo(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const userProfileGet = createAsyncThunk('profile/userProfileGet', async (_, {dispatch}) => {
  try {
    dispatch(setLoading(true))
    dispatch(setRedirect(false))
    const response = await getUserProfileClient.get()
    dispatch(setUserProfile(response))
    return response
  } catch (error) {
    AuthCheck(error)
    dispatch(setError(error))
    throw error
  }
})

export const userProfileUpdate = createAsyncThunk(
  'profile/userProfileUpdate',
  async (params, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      dispatch(setRedirect(false))
      const response = await updateUserProfileClient.update(params)
      dispatch(setRedirect(response || params))
      dispatch(setUserProfile(params))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setUserProfile(params))
      dispatch(setError(error))
      throw error
    }
  }
)

// Slice
const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setInfo: (state, action) => {
      state.info = action.payload
      state.loading = false
    },
    setUserProfile: (state, action) => {
      state.userProfile = action.payload
      state.loading = false
    },
    setDeleted: (state, action) => {
      state.isDeleted = action.payload
      state.loading = false
    },
    setRedirect: (state, action) => {
      state.isRedirect = action.payload
      state.loading = false
    },
    setArchived: (state, action) => {
      state.isArchived = action.payload
      state.loading = false
    },
    resetState: (state) => {
      Object.assign(state, initialState)
    },
  },
})

// Export actions
export const {
  setLoading,
  setError,
  setInfo,
  setUserProfile,
  setDeleted,
  setRedirect,
  setArchived,
  resetState,
} = profileSlice.actions

// Selectors
export const selectProfileLoading = (state) => state.profile.loading
export const selectProfileError = (state) => state.profile.error
export const selectProfileInfo = (state) => state.profile.info
export const selectProfileUserProfile = (state) => state.profile.userProfile
export const selectProfileDeleted = (state) => state.profile.isDeleted
export const selectProfileRedirect = (state) => state.profile.isRedirect
export const selectProfileArchived = (state) => state.profile.isArchived

export default profileSlice.reducer
